export const TeamChatEntityChipTestIds = {
  CHIP: 'team-chat.entity-chip',
  HOVER_HINT: 'team-chat.entity-chip-hover-hint',
};
